import moment from "moment";
import ProductSelectionComponent from "../../../../components/model-management/product-selection.component";
import paginationComponent from "../../../../components/pagination/pagination.component";
import SingleSelectComponent from "../../../../components/single-select/single-select.component";
import SelectSiteSearchInputComponent from "../../../../components/site/select-site-search-input.component";
import SoldToSearchInputComponent from "../../../../components/simple-search/sold-to-search-input.component";
import { formats } from "../../../../config/constants";
import GSBNMappingModel from "../../../../models/gsbn-mapping-management/gsbn-mapping-management.model";
import ViewBase from "../../../view-base.view";
import GSBNMappingUploadDialog from "./gsbn-mapping-management.excel-upload.dialog";
/**
 * GSBN Mapping Management View
 * 
 * A page that displays a list of GSBN Mapping and Upload and Download feature
 * 
 * @author cmcnkhiep
 */

export default function GSBNMappingManagementView() {

    ViewBase.call(this);

    const IS_MAPPING_OPTIONS = [
        { code: "N", name: "No" },
        { code: "Y", name: "Yes" },
    ];

    const DEFAULT_FILTERS = {
        sites: [],
        soldTos: [],
        prodHir: [],
        flagMap: '',
    };

    const DEFAULT_PAGINATION = {
        pageSize: 10,
        pageIndex: 1,
        totalItems: 0
    };

    let filters = structuredClone(DEFAULT_FILTERS);
    let currentFilters = structuredClone(DEFAULT_FILTERS);
    let pagination = structuredClone(DEFAULT_PAGINATION);

    let tableData = [];
    let isExcelUploadOpen = false;

    const toQueryParams = (params) => {
        return Object.assign(
            {
                pageSize: pagination.pageSize,
                pageIndex: pagination.pageIndex,
                siteCode: params.sites.map(({ siteId }) => siteId),
                soldToCode: params.soldTos.map(({ code }) => code),
                prodHir: params.prodHir,
                flagMap: params.flagMap,
            },
        );
    };

    const clearFilter = () => {
        filters = structuredClone(DEFAULT_FILTERS);
    };

    const getGSBNMapping = () => {
        this.showLoading();

        GSBNMappingModel.searchGSBNMapping(toQueryParams(currentFilters)).then((result) => {
            tableData = result.data;
            pagination.pageIndex = result.pageIndex;
            pagination.pageSize = result.pageSize;
            pagination.totalItems = result.total;

        }).catch((error) => {
            this.handleError(error);
        }).finally(() => {
            this.hideLoading();
        })
    }

    const downloadGSBNMapping = () => {
        this.showLoading();
        GSBNMappingModel.downloadGSBNMappingExcel(toQueryParams(currentFilters)).catch((error) => {
            this.handleError(error);
        }).finally(() => {
            this.hideLoading();
        })
    }
    return {
        view: () => {
            return [
                /* SEARCH */
                m('.card.mb-3',
                    m('.card-body',
                        m('form', {
                            onsubmit: (e) => {
                                e.preventDefault();
                                pagination = structuredClone(DEFAULT_PAGINATION);
                                currentFilters = structuredClone(filters)
                                getGSBNMapping();
                            }
                        },
                            m('.row.g-2',
                                m('.col-xl-3.col-lg-4.col-sm-6.position-relative',
                                    m('label.form-label[for="site"]', this.getText('LT00000071', 'Site')),
                                    m(SelectSiteSearchInputComponent, {
                                        id: 'site',
                                        multiple: true,
                                        selectedItems: filters.sites,
                                        onSelect: (selectedItems) => { filters.sites = selectedItems; }
                                    })
                                ),
                                m('.col-xl-3.col-lg-4.col-sm-6.position-relative',
                                    m('label.form-label[for="soldTo"]', this.getText('LT00000991', 'Sold To')),
                                    m(SoldToSearchInputComponent, {
                                        id: 'soldTo',
                                        multiple: true,
                                        selectedItems: filters.soldTos,
                                        onSelect: (selectedItems) => { filters.soldTos = selectedItems; },
                                    }),

                                ),
                                m('.col-xl-3.col-lg-4.col-sm-6.position-relative',
                                    m('label.form-label[for=product]', this.getText('LT00000579', 'Product')),
                                    m(ProductSelectionComponent, {
                                        id: 'product',
                                        selectedItems: filters.prodHir,
                                        onChange: (selectedItems) => {
                                            filters.prodHir = selectedItems;
                                        }
                                    })
                                ),
                                m('.col-xl-3.col-lg-4.col-sm-6.position-relative',
                                    m('label.form-label[for=isMapping]', this.getText('LT00000992', 'Is Mapping')),
                                    m(SingleSelectComponent, {
                                        id: "isMapping",
                                        class: "form-control",
                                        items: IS_MAPPING_OPTIONS,
                                        keyOnly: true,
                                        allowEmpty: true,
                                        filterable: false,
                                        selectedItem: filters.flagMap,
                                        onSelect: (selectedItems) => {
                                            filters.flagMap = selectedItems;
                                        },
                                    })
                                ),
                                m('.col-12.d-flex.justify-content-end.gap-2',
                                    m('button.btn.btn-primary',
                                        {
                                            type: 'submit',
                                        },
                                        this.getText("LT00000001", "Search")
                                    ),
                                    m('button.btn.btn-white',
                                        {
                                            type: 'button',
                                            onclick: () => {
                                                clearFilter();
                                            }
                                        },
                                        this.getText("LT00000031", "Clear")
                                    )
                                )
                            )
                        ),

                    )
                ),

                /* TABLE */
                m('.card',
                    m('.card-body',
                        m('.row.g-2',
                            m('.col-12.d-flex.justify-content-end',
                                m('.d-flex.gap-2',
                                    m('button.btn.btn-primary',
                                        {
                                            onclick: () => { isExcelUploadOpen = true; }
                                        },
                                        m('i.bi.bi-file-earmark-arrow-up-fill'),
                                        this.getText('LT00000197', 'Excel Upload')
                                    ),
                                    m('button.btn.btn-primary',
                                        {
                                            disabled: tableData.length === 0,
                                            onclick: downloadGSBNMapping
                                        },
                                        m('i.bi.bi-file-earmark-arrow-down-fill'),
                                        this.getText('LT00000018', 'Excel Download')
                                    )
                                )
                            ),
                            m('.col-12',
                                m('.table-responsive',
                                    m('table.table.table-hover',
                                        m('thead',
                                            m('tr.align-middle',
                                                m('th[scope="col"]', this.getText('LT00000723', 'Site Code')),
                                                m('th[scope="col"]', this.getText('LT00000144', 'Site Name')),
                                                m('th[scope="col"]', this.getText('LT00000993', 'Sold To Code')),
                                                m('th[scope="col"]', this.getText('LT00000994', 'Sold To Name'),),
                                                m('th[scope="col"]', this.getText('LT00000995', 'Ship To Code'),),
                                                m('th[scope="col"]', this.getText('LT00000996', 'Ship To Name'),),
                                                m('th[scope="col"]', this.getText('LT00000997', 'SALES[P4W]')),
                                                m('th[scope="col"]', this.getText('LT00000998', 'INV[P4W]')),
                                                m('th[scope="col"]', this.getText('LT00000709', 'Created By')),
                                                m('th[scope="col"]', this.getText('LT00000885', 'Created On')),
                                                m('th[scope="col"]', this.getText('LT00000710', 'Updated By')),
                                                m('th[scope="col"]', this.getText('LT00000887', 'Updated On')),
                                            )
                                        ),
                                        m('tbody',
                                            (tableData.length == 0) &&
                                            m('tr.align-middle',
                                                m('td[colSpan=13]', this.getText("EM00000141", "No records found."))
                                            ),
                                            tableData.length > 0 &&
                                            tableData.map((data, index) =>
                                                m('tr.align-middle',
                                                    m('td', m('span.cursor-text', data.siteCode)),
                                                    m('td', m('span.cursor-text', data.siteName)),
                                                    m('td', m('span.cursor-text', data.soldToCode)),
                                                    m('td', m('span.cursor-text', data.soldToName)),
                                                    m('td', m('span.cursor-text', data.shipToCode)),
                                                    m('td', m('span.cursor-text', data.shipToName)),
                                                    m('td', m('span.cursor-text', data.sales)),
                                                    m('td', m('span.cursor-text', data.inventory)),
                                                    m('td', m('span.cursor-text', data.createUID)),
                                                    m('td', m('span.cursor-text', data.createDate?.trim() ? moment(data.createDate).format(formats.LOCAL_TIME) : '')),
                                                    m('td', m('span.cursor-text', data.updateUID)),
                                                    m('td', m('span.cursor-text', data.updateDate?.trim() ? moment(data.updateDate).format(formats.LOCAL_TIME) : '')),
                                                )
                                            )
                                        )
                                    )
                                )
                            ),
                            tableData.length > 0 &&
                            m('.col-12', m(paginationComponent,
                                {
                                    currentPage: pagination.pageIndex,
                                    pageSize: pagination.pageSize,
                                    totalItems: pagination.totalItems,
                                    onPageChanged: (pageIndex) => {
                                        pagination.pageIndex = pageIndex;
                                        getGSBNMapping();
                                    },
                                    onPageSizeChanged: (pageIndex, pageSize) => {
                                        pagination.pageSize = pageSize;
                                        pagination.pageIndex = pageIndex;
                                        getGSBNMapping();
                                    }
                                }
                            )),
                        )
                    )
                ),

                /* EXCEL UPLOAD DIALOG */
                m(GSBNMappingUploadDialog,
                    {
                        isOpen: isExcelUploadOpen,
                        onClose: () => { isExcelUploadOpen = false; }
                    }
                ),
                this.getBaseViews()
            ];
        }
    };
}
